import React from "react"
import { graphql } from "gatsby"
import Img from "gatsby-image"
import styled from "@emotion/styled"
import Layout from "../components/layout"
import SplitText from "react-pose-text"
import Badge from "react-bootstrap/Badge"
import ListGroup from "react-bootstrap/ListGroup"
import SimpleSlider from "../components/slider"

const Heading = styled.h2`
  color: darkorange;
  margin-right: 1em;
  margin-bottom: -0.2em;
  @media (max-width: 600px) {
    margin-bottom: 2px;
  }
`

const HeaderGroup = styled.div`
  margin-top: 60px;
  display: flex;
  align-items: flex-end;
  align-content: flex-end;
  flex-direction: row;
  @media (max-width: 600px) {
    flex-direction: column;
    align-content: flex-start;
    align-items: flex-start;
    justify-content: "space-evenly";
  }
`

const SubHead = styled.h5`
  margin: 1em 0 1em 0;
`

const MainText = styled.p`
  margin-bottom: 2em;
`

const charPoses = {
  exit: { opacity: 0, y: 20 },
  enter: {
    opacity: 1,
    y: 0,
    delay: ({ charIndex }) => charIndex * 5,
  },
}

const ImageContainer = styled.div`
  max-width: 1000px;
`

const StyledImg = styled(Img)`
  border: 10px solid #373a47;
  border-radius: 10px;
  margin-top: 1.5em;
  margin-bottom: 2em;
`

export default ({ data }) => {
  const tool = data.allContentfulTool.edges[0]
  console.log(tool.node.screenshots)

  return (
    <Layout>
      <HeaderGroup>
        <Heading>
          <SplitText initialPose="exit" pose="enter" charPoses={charPoses}>
            {tool.node.name}
          </SplitText>
        </Heading>
        <span>
          <Badge variant="dark">{tool.node.type}</Badge>
          {tool.node.technologies.map(tech => (
            <Badge style={{ marginLeft: 5 }} variant="info">
              {tech}
            </Badge>
          ))}
        </span>
      </HeaderGroup>
      <ImageContainer>
        <StyledImg fluid={tool.node.cardImage.fluid} />
      </ImageContainer>
      <MainText>{tool.node.description.description}</MainText>
      {tool.node.coursesUsed ? (
        <>
          <SubHead>Courses used</SubHead>
          <ListGroup>
            {tool.node.coursesUsed.map(course => (
              <ListGroup.Item
                action
                href={"https://canvas.sfu.ca/courses/" + course.canvasId}
                target="_blank"
                rel="noopener"
              >
                {course.courseCode + " " + course.title}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </>
      ) : null}
      {tool.node.screenshots ? (
        <>
          <SubHead>Gallery</SubHead>
          <SimpleSlider images={tool.node.screenshots} />
        </>
      ) : null}
    </Layout>
  )
}

export const query = graphql`
  query($id: String!) {
    allContentfulTool(filter: { id: { eq: $id } }) {
      edges {
        node {
          name
          description {
            description
          }
          type
          technologies
          coursesUsed {
            canvasId
            title
            courseCode
          }
          cardImage {
            fluid(maxWidth: 1000) {
              ...GatsbyContentfulFluid
            }
          }
          screenshots {
            fluid(maxWidth: 600) {
              ...GatsbyContentfulFluid
            }
          }
        }
      }
    }
  }
`
